import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { EntityCardBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { isGeography } from '@internal/geography-common';

export const geographyModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [
    EntityCardBlueprint.make({
      name: 'geography',
      params: {
        filter: entity =>
          isGeography(entity) || Array.isArray(entity.spec?.locationRefs),
        loader: () => import('./GeographyCard').then(m => <m.GeographyCard />),
      },
    }),
  ],
});
